import React, { Component } from 'react';
import Select from 'react-select';
import './ReduxFormStyles.scss';

export default class LeavingSelectField extends Component {
  render() {
    const {
      input,
      placeholder,
      options,
      meta: { touched, error },
    } = this.props;

    const handleChange = (data) => {
      input.onChange(data ? data.value : '');
    };
    return (
      <div className={touched && error ? ' has-error' : ''}>
        <div>
          <Select
            options={options}
            value={options.find((opt) => {
              return opt.value === input.value.value;
            })}
            placeholder={placeholder || 'Select...'}
            // onBlur={() => (input.onBlur ? input.onBlur(input.value) : '')}
            onChange={handleChange}
          />
        </div>
        {touched && error && <span className="input-error-leaving">{error}</span>}
      </div>
    );
  }
}
